<template>
	<div :id="['about']">
		<svg viewBox="0 0 1 1" preserveAspectRatio="none">
			<defs>
				<clipPath id="clipPath" clipPathUnits="objectBoundingBox">
					<path :d="path"/>
				</clipPath>
				<clipPath id="clipPathBackground" clipPathUnits="objectBoundingBox">
					<path :d="path2"/>
				</clipPath>
			</defs>
		</svg>
		<div class="wrapper" :style="{'--progression': progression}">
			<div class="background" :style="{'--progression': progression2}"></div>
			<div class="content">
				<h1>About</h1>
				<div class="text" v-if="page" v-html="page.fields.text" ref="text"></div>
				<div class="links" ref="links">
					<a class="contact-link" href="https://github.com/thomasboulongne" target="_blank" rel="noopener">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.6 31.8">
							<path d="M16.3 0A16.3 16.3 0 0 0 11 31.8c.9.1 1.1-.4 1.1-.8v-2.8c-4.5 1-5.5-2.2-5.5-2.2A4.4 4.4 0 0 0 5 23.6c-1.4-1 .1-1 .1-1a3.4 3.4 0 0 1 2.5 1.7 3.5 3.5 0 0 0 4.8 1.3 3.5 3.5 0 0 1 1-2.1c-3.6-.4-7.4-1.8-7.4-8A6.3 6.3 0 0 1 7.5 11a6 6 0 0 1 .2-4.3s1.4-.5 4.5 1.7a15.4 15.4 0 0 1 8.1 0c3.1-2.2 4.5-1.7 4.5-1.7A6 6 0 0 1 25 11a6.3 6.3 0 0 1 1.7 4.3c0 6.3-3.8 7.7-7.5 8a3.9 3.9 0 0 1 1.1 3V31c0 .5.3 1 1.2.8A16.3 16.3 0 0 0 16.3 0z" fill="#000000" fill-rule="evenodd"/>
						</svg>
					</a>
					<a class="contact-link" href="https://www.behance.net/thomasboul6a56" target="_blank" rel="noopener">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"/>
						</svg>
					</a>
					<div class="contact-link mail-link" @click="copyMailToClipboard">
						<span class="tooltip" v-html="mailTooltip"></span>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" x="0px" y="0px">
							<path d="M88,17.25H11.4a6.71,6.71,0,0,0-6.4,7V76a6.77,6.77,0,0,0,6.6,6.8H88a7,7,0,0,0,7-7V24.25A7,7,0,0,0,88,17.25ZM17,23.81H83a.87.87,0,0,1,.55,1.55L53.49,49.51a5.55,5.55,0,0,1-7,0L16.47,25.36A.87.87,0,0,1,17,23.81ZM89.73,74a3.58,3.58,0,0,1-3.59,3.58H13.92A3.58,3.58,0,0,1,10.33,74V31.09a1.57,1.57,0,0,1,2.56-1.21L43.38,54.94a10.46,10.46,0,0,0,13.3,0L87.17,29.88a1.57,1.57,0,0,1,2.56,1.21Z"/>
						</svg>
					</div>
				</div>
			</div>
			<router-link to="/">
				<div class="homelink" ref="homeLink" @mouseenter="homeLinkEnter" @mouseleave="homeLinkLeave"><span>Work</span></div>
			</router-link>
		</div>
	</div>
</template>
<script>
import 'lining.js/build/lining.min.js'
export default {
	data() {
		return {
			mousePosition: {
				x: 0,
				y: 0
			},
			progression: 0,
			easedProgression: 0,
			progression2: 0,
			easedProgression2: 0,
			mailTooltip: 'Copy email address to clipboard'
		}
	},
	computed: {
		page: function() {
			return this.$store.getters['pages/page']('about')
		},
		stateMousePosition: function() {
			return this.$store.getters['ui/mousePosition']
		},
		viewportSize: function() {
			return this.$store.getters['ui/viewportSize']
		},
		path: function() {
			return `
				M 0,0
				L ${this.progression},0
				C ${this.easedProgression},0.25 ${this.easedProgression},0.75 ${this.progression},1
				L 0,1
				L 0,0
			`
		},
		path2: function() {
			return `
				M 1,0
				L 1,1
				L ${this.progression2},1
				C ${this.easedProgression2},0.75 ${this.easedProgression2},0.25 ${this.progression2},0
			`
		}
	},
	watch: {
		stateMousePosition: function(position) {
			TweenMax.to(this.mousePosition, 0.4, {
				x: (position.x - this.$store.getters['ui/viewportSize'].width / 2) / 30,
				y: (position.y - this.$store.getters['ui/viewportSize'].height / 2) / 30,
				ease: Power3.easeOut
			})
		},
		page: function() {
			this.$nextTick(() => {
				if (this.$refs.text) {
					this.lining = lining(this.$refs.text)
				}
			})
		},
		viewportSize: function() {
			if (this.lining) {
				this.lining.relining()
			}
		}
	},
	mounted() {
		if (this.$refs.text) {
			this.lining = lining(this.$refs.text)
		}
	},
	methods: {
		showTimeline() {
			const tl = new TimelineMax({
				onComplete: () => {
					this.$store.dispatch('ui/unblockOverflow')
				}
			})
			const duration = 0.5
			tl
			.set(this.$refs.text, {
				opacity: 1
			})
			.staggerFromTo(this.$refs.text.querySelectorAll('text-line'), duration * 1.9, {
				y: 25
			},{
				y: 0,
				ease: Power4.easeOut
			}, 0.02)
			.staggerFromTo(this.$refs.text.querySelectorAll('text-line'), duration * 1.9, {
				opacity: 0
			},{
				opacity: 1
			}, 0.02, 0)
			.staggerTo(this.$refs.links.querySelectorAll('.contact-link'), duration * 0.6, {
				'--icon-clip-x': 100,
				ease: Power4.easeOut
			}, 0.08, '-=0.8')
			.to(this.$refs.homeLink, 1.2, {
				'--homelink-clip-x': 100,
				ease: Power4.easeOut
			}, 0.6)
			return tl
		},
		openningWave(duration = 0.9) {
			const tl = new TimelineMax()
			tl
			.to(this, 0.8 * duration, {
				progression: 1,
				ease: Power2.easeInOut
			})
			.to(this, 1 * duration, {
				easedProgression: 1,
				ease: Power2.easeOut
			}, 0)
			.add('secondPath', '-=' + (0.6 * duration))
			.to(this, 0.8 * duration, {
				progression2: 1,
				ease: Power2.easeInOut
			}, 'secondPath')
			.to(this, 1 * duration, {
				easedProgression2: 1,
				ease: Power2.easeOut
			}, 'secondPath')
			return tl
		},
		closingWave(duration = 0.9) {
			const tl = new TimelineMax()
			tl
			.to(this, 0.8 * duration, {
				progression2: 0,
				ease: Power2.easeInOut
			})
			.to(this, 1 * duration, {
				easedProgression2: 0,
				ease: Power2.easeOut
			}, 0)
			.add('secondPath', '-=' + (0.6 * duration))
			.to(this, 0.8 * duration, {
				progression: 0,
				ease: Power2.easeInOut
			}, 'secondPath')
			.to(this, 1 * duration, {
				easedProgression: 0,
				ease: Power2.easeOut
			}, 'secondPath')
			return tl
		},
		homeLinkEnter() {
			const tl = new TimelineMax({paused: true})
			const duration = 2
			tl
			.to(this.$refs.homeLink, 0.3 * duration, {
				'--homelink-underline-scale': 1,
				color: '#ffffff',
				overwrite: 'preexisting',
				ease: Power4.easeIn
			})
			.set(this.$refs.homeLink, {
				'--homelink-underline-origin': 'top'
			})
			.to(this.$refs.homeLink, 0.13 * duration, {
				'--homelink-underline-scale': 0.1,
				color: '#aaaaaa',
				ease: Power4.easeOut
			})
			tl.play()
		},
		homeLinkLeave() {
			if (this.$refs.homeLink) {
				const tl = new TimelineMax({paused: true})
				const duration = 2
				tl
				.to(this.$refs.homeLink, 0.2 * duration, {
					'--homelink-underline-scale': 1,
					color: '#ffffff',
					overwrite: 'preexisting',
					ease: Power4.easeIn
				})
				.set(this.$refs.homeLink, {
					'--homelink-underline-origin': 'bottom'
				})
				.to(this.$refs.homeLink, 0.1 * duration, {
					'--homelink-underline-scale': 0.1,
					color: '#aaaaaa',
					ease: Power4.easeOut
				})
				tl.play()
			}
		},
		copyMailToClipboard: function() {
			navigator.clipboard.writeText('thomasboulongne@hotmail.com')
			.then(() => {
				this.mailTooltip = 'Copied!'
				setTimeout(() => {
					this.mailTooltip = 'Copy email address to clipboard'
				}, 1500);
			})
		}
	}
}
</script>
<style lang="sass">
#about
	z-index: 4
	position: relative
	svg
		height: 0
		width: 0
		position: absolute
		pointer-events: none
	.wrapper
		min-height: 100vh
		min-width: 100vw
		clip-path: url(#clipPath)
		--progression: 0
		@supports (-webkit-marquee-repetition:infinite) and (object-fit:fill)
			clip-path: polygon(0% 0%, calc(var(--progression) * 100%) 0%, calc(var(--progression) * 100%) 100%, 0% 100%)
		background: white
		.background
			display: block
			position: absolute
			top: 0
			right: 0
			bottom: 0
			left: 0
			background: black
			clip-path: url(#clipPathBackground)
			--progression: 0
			@supports (-webkit-marquee-repetition:infinite) and (object-fit:fill)
				clip-path: polygon(calc(var(--progression) * 100%) 0%, 100% 0%, 100% 100%, calc(var(--progression) * 100%) 100%)
			z-index: 1
		.content
			z-index: 1
			position: relative
			width: 100%
			max-width: 68rem
			margin: auto
			display: flex
			flex-direction: column
			justify-content: center
			align-items: center
			padding: 15vh 10vw
			h1
				font-family: var(--serif)
				font-size: var(--title-size)
				-webkit-text-stroke: 1px white
				text-stroke: 1px white
				margin-bottom: 4rem
			.text
				font-size: 1.4rem
				opacity: 0
			.links
				display: flex
				align-self: flex-start
				.contact-link
					margin: 2rem
					display: block
					--icon-clip-x: 0
					width: 2rem
					height: 2rem
					&:first-child
						margin-left: 0
					svg
						width: 2rem
						height: 2rem
						clip-path: polygon(0% 0%, calc(var(--icon-clip-x) * 1%) 0%, calc(var(--icon-clip-x) * 1%) 100%, 0% 100%)
					&.mail-link
						position: relative
						cursor: pointer
						.tooltip
							position: absolute
							opacity: 0
							pointer-events: none
							top: calc(100% + 0.5rem)
							left: 50%
							transform: translateX(-50%) scale(0.5)
							transform-origin: top
							padding: 0.8em 0.4em
							background: black
							color: white
							border-radius: 0.3em
							width: 10em
							text-align: center
							transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.2s
						&:hover
							.tooltip
								opacity: 1
								transform: translateX(-50%) scale(1)

		.homelink
			--padding-x: 1.5em
			--padding-y: 0.5em
			position: fixed
			padding: var(--padding-y) var(--padding-x)
			font-size: 1rem
			top: 50%
			right: 0
			transform: rotate(90deg)
			font-family: sans-serif
			color: var(--grey)
			display: inline-block
			z-index: 0
			cursor: pointer
			--homelink-underline-scale: 0.1
			--homelink-underline-origin: bottom
			--homelink-clip-x: 0
			clip-path: polygon(0% 0%, calc(var(--homelink-clip-x) * 1%) 0%, calc(var(--homelink-clip-x) * 1%) 100%, 0% 100%)
			@media screen and (max-width: 414px)
				top: 2rem
				left: 50%
				right: auto
				z-index: 1
				transform: translateX(-50%)
			span
				position: relative
			&:before
				content: ''
				position: absolute
				top: 0
				right: var(--padding-x)
				bottom: 0
				left: var(--padding-x)
				background-color: var(--grey)
				transform: scaleY(var(--homelink-underline-scale))
				transform-origin: var(--homelink-underline-origin)
</style>



// WEBPACK FOOTER //
// src/components/About.vue